import { render, staticRenderFns } from "./PublicActivation.vue?vue&type=template&id=0230d4f3&scoped=true"
import script from "./PublicActivation.vue?vue&type=script&lang=js"
export * from "./PublicActivation.vue?vue&type=script&lang=js"
import style0 from "./PublicActivation.vue?vue&type=style&index=0&id=0230d4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230d4f3",
  null
  
)

export default component.exports